import React from 'react';
import { MapPin } from 'lucide-react';

const Header = () => {
  return (
    <header className="bg-white dark:bg-gray-800 shadow-sm border-b dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="rounded-lg">
              <img
                src="https://mockimg.co/100x100"
                alt="Echo Sound Lab Logo"
                className="h-10 w-10 object-contain"
              />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Jammed v2</h1>
          </div>
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-7">
              <a href="#" className="text-gray-600 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">
                Login
              </a>
              <a href="#" className="text-gray-600 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">
                Register
              </a>
            </div>

            <div className="text-right">
              <span className="text-lg text-gray-600 font-bold">
                <MapPin className="inline h-4 w-4 mr-1" />
                Echo Sound Lab, Austin
              </span>
              <p className="text-sm text-gray-500">1234 Harmony Ave, Austin, TX 78701</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;